module.exports = "<mat-icon *ngIf=\"(error$ |async)\"  color=\"accent\" class=\"icon-disp\"> highlight_off </mat-icon>\n"